<template>
  <div class="bg-light border-bottom border-primary border-width-2 py-4">
    <div class="container">
      <div class="row align-items-center mt-4 pt-4" :class="{ 'pb-4': $auth.admin() }">
        <div :class="{ 'col-sm-12': $auth.admin(), 'col-sm-6': !$auth.admin() }">
          <h2 class="h1">
            <template v-if="!create && project">
              &apos;<span class="d-inline-block mb-3">
                <editable-content attribute="name" service="projects" />
              </span>&apos;
              <br>
              <slot />
            </template>
            <template v-else>
              <span class="d-inline-block mb-3">Loan Application</span>
              <br>
              Create New Project
            </template>
          </h2>
          <template v-if="back">
            <base-button class="mt-3" exact icon-left="arrow-left" secondary :to="{ name: 'projects.dashboard', params: { id: project._id } }">
              Back to Dashboard
            </base-button>
          </template>
        </div>
        <div v-if="!$auth.admin()" class="col-sm-6">
          <user-relationship-manager no-border :user="user" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import EditableContent from './EditableContent.vue'
import UserRelationshipManager from './UserRelationshipManager.vue'

export default {
  name: 'ProjectHeading',

  components: {
    EditableContent,
    UserRelationshipManager
  },

  props: {
    back: Boolean,
    create: Boolean
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity,
      user: store => store.core.auth.user
    })
  }
}
</script>
